<template>
  <b-row>
    <b-col md="3">
      <b-card bg-variant="primary">
        <h5 class="text-white">
          <feather-icon icon="PocketIcon" size="20" />
          {{ getOneClient.title }}
        </h5>
        <div>
          <small class="text-white">
            {{ getOneClient.description }}
          </small>
        </div>
        <div class="text-white pt-2">
          <feather-icon icon="UserCheckIcon" size="18" />
          <small class="pl-1">
            {{
              getOneClient.gender === "man"
                ? $t("clients.man")
                : getOneClient.gender === "woman"
                ? $t("clients.woman")
                : $t("clients.no_information")
            }}
          </small>
        </div>

        <div class="text-white">
          <feather-icon icon="ClockIcon" size="18" />
          <small class="pl-1">{{
            $_dateTimeFormatter(getOneClient.created_date)
          }}</small>
        </div>

        <div class="text-white">
          <feather-icon icon="UserCheckIcon" size="18" />
          <small class="pl-1">{{ $t(getOneClient.client_entity) }}</small>
        </div>

        <div
          v-for="(email, index) in getOneClient.emails"
          :key="index"
          class="text-white pt-2"
        >
          <feather-icon icon="MailIcon" size="18" />
          <small v-if="email" class="pl-1">{{ email }}</small>
          <small v-else class="pl-1">{{ $t("clients.no_information") }}</small>
        </div>
        <div
          v-for="(phone, index) in getOneClient.phones"
          :key="index"
          class="text-white pb-2"
        >
          <feather-icon icon="PhoneIcon" size="18" />
          <small v-if="getOneClient.phones" class="pl-1">{{ phone }}</small>
          <small v-else class="pl-1">{{ $t("clients.no_information") }}</small>
        </div>

        <div v-if="getOneClient.manager" class="text-white">
          <feather-icon icon="UserIcon" size="18" />
          <small class="pl-1">{{ getOneClient.manager.first_name }}</small>
        </div>

        <div v-if="getOneClient.target" class="text-white">
          <feather-icon icon="CastIcon" size="18" />
          <small class="pl-1">{{ getOneClient.target.title }}</small>
        </div>
        <div v-if="getOneClient.status_of_client" class="text-white">
          <feather-icon icon="UserIcon" size="18" />
          <small class="pl-1">{{ getOneClient.status_of_client }}</small>
        </div>
        <div v-if="getOneClient.sphere_of_activity" class="text-white">
          <feather-icon icon="UserIcon" size="18" />
          <small class="pl-1">{{
            getOneClient.sphere_of_activity.title
          }}</small>
        </div>
        <div class="d-flex justify-content-end">
          <span v-b-modal.edit-client class="text-white edit-button">
            <feather-icon icon="EditIcon" size="18" />
          </span>
        </div>
      </b-card>

      <!-- Employees card -->
      <div v-for="employee in getOneClient.employee" :key="employee.id">
        <b-card bg-variant="success">
          <b-row>
            <b-col md="10">
              <h5 class="text-white">
                <feather-icon icon="UserIcon" size="20" />
                {{ employee.name }}
              </h5>

              <div v-if="employee.phones[0]" class="text-white pt-1">
                <feather-icon icon="PhoneIcon" size="18" />
                <small class="pl-1">{{ employee.phones[0] }}</small>
              </div>
            </b-col>
            <b-col md="2">
              <b-button
                variant="link"
                class="text-white edit-button"
                @click="editEmployee(employee)"
              >
                <feather-icon icon="EditIcon" size="18" />
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <b-card bg-variant="success">
        <div>
          <span class="text-white cursor" @click="openNewEmployeeModal">
            <feather-icon icon="PlusCircleIcon" size="24" />
            {{ $t("clients.add_client") }}
          </span>
        </div>
      </b-card>
    </b-col>

    <b-col md="9">
      <b-card>
        <b-tabs fill>
          <b-tab :title="$t('clients.comments')">
            <Comments />
          </b-tab>
          <b-tab
            v-if="GET_CLIENT_DATA_TO_EDIT.entity === 'yuridiskiy'"
            :title="$t('clients.client_requisites')"
          >
            <AdditionalInfoclient @refresh="refresh" />
          </b-tab>
          <b-tab :title="$t('clients.file')">
            <Files />
          </b-tab>
          <b-tab :title="$t('clients.installment_by_contract')">
            <div v-if="GET_PAYMENT_INTALLMENTS.length === 0" class="no__data">
              <span>{{ $t("clients.no_contracts") }}</span>
            </div>
            <CollapsibeContractCard
              v-for="contract in GET_PAYMENT_INTALLMENTS"
              :key="contract.id"
              :contract="contract"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>

    <EditClientModal
      :client-info="GET_CLIENT_DATA_TO_EDIT"
      @refresh="refresh"
    />
    <EmployeeModal
      :is-edit="employee_editing"
      :parent_id="Number($route.params.id)"
      :employee="employee_data"
      @refresh="refresh"
      @success="refresh"
    />
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BTabs, BTab, BButton } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import EditClientModal from "./components/EditClientModal.vue";
import EmployeeModal from "./components/EmployeeModal.vue";
import Comments from "./components/Сomments.vue";
import AdditionalInfoclient from "./components/AdditionalInfoclient.vue";
import Files from "./components/Files.vue";
import formatters from "@/mixins/extra";
import CollapsibeContractCard from "./components/CollapsibeContractCard.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTab,
    BTabs,
    EditClientModal,
    EmployeeModal,
    CollapsibeContractCard,
    Comments,
    AdditionalInfoclient,
    Files,
    BButton,
  },
  mixins: [formatters],
  data() {
    return {
      editEmployeeData: null,
      employee_data: {
        phones: [],
        passport: {},
        info: {},
      },
      employee_editing: false,
    };
  },
  computed: {
    ...mapGetters("clients", [
      "getOneClient",
      "getContracts",
      "GET_CLIENT_DATA_TO_EDIT",
      "GET_PAYMENT_INTALLMENTS",
    ]),
  },

  async mounted() {
    this.refresh();
  },

  methods: {
    ...mapActions("clients", [
      "FETCH_ONE_CLIENT",
      "FETCH_CONTRACT_LIST",
      "FETCH_INSTALLMENTS_CONTRACT",
    ]),
    openNewEmployeeModal() {
      this.employee_editing = false;
      this.employee_data = {
        phones: [],
        passport: {},
        info: {},
      };
      this.$nextTick(() => {
        this.$bvModal.show("employee-modal");
      });
    },
    editEmployee(data) {
      this.employee_editing = true;
      this.employee_data = data;
      this.$nextTick(() => {
        this.$bvModal.show("employee-modal");
      });
    },
    refresh() {
      this.FETCH_ONE_CLIENT(this.$route.params.id);
      this.FETCH_INSTALLMENTS_CONTRACT(this.$route.params.id);
    },
    clearEditData() {
      this.editEmployeeData = null;
    },
  },
};
</script>

<style scoped>
.edit-button {
  padding: 3px 5px;
  border-radius: 4px;
  border: 1px solid #fff;
  cursor: pointer;
}

.cursor {
  cursor: pointer;
}

.no__data {
  border: 1px dashed #ccc;
  padding: 50px;
  width: 100%;
  text-align: center;
  border-radius: 5px;
}
</style>
